import { render, staticRenderFns } from "./PhotographyPage.vue?vue&type=template&id=21d4db4f&scoped=true&"
import script from "./PhotographyPage.vue?vue&type=script&lang=js&"
export * from "./PhotographyPage.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyPage.vue?vue&type=style&index=0&id=21d4db4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4db4f",
  null
  
)

export default component.exports